// extracted by css-extract-rspack-plugin
export default {"footnote":"XJKpJxpbkQNwxXWl","footnote_none":"eXRFpEAxCi8fxHu4"};